module.exports = __webpack_public_path__ + "static/media/bg3t.393fb2ba.svg";